/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Dialogue_TitlecaseInputs */



/**
* | output |
* | --- |
* | "Dialogue" |
*
* @param {Ccsl_Export_Header_Dialogue_TitlecaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_dialogue_titlecase = /** @type {((inputs?: Ccsl_Export_Header_Dialogue_TitlecaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Dialogue_TitlecaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dialogue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dialogo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Диалог")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diálogo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対話")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वार्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diálogo")
	return /** @type {LocalizedString} */ ("Dialogue")
});